import { createError } from '@common/neo.tax';

import { FilterSortDataType } from '@neo.tax/shared/utils';

import { OperatorName } from './hooks';

export const makeFilterOperator = (
  dataType: FilterSortDataType,
  operator: OperatorName,
  expectedValue: string,
): ((actualValues: string[]) => boolean) => {
  switch (operator) {
    case OperatorName.STARTS_WITH:
      return (actualValues: string[]): boolean => actualValues.some((a) => a.startsWith(expectedValue));
    case OperatorName.ENDS_WITH:
      return (actualValues: string[]): boolean => actualValues.some((a) => a.endsWith(expectedValue));
    case OperatorName.IS:
      return (actualValues: string[]): boolean => actualValues.some((a) => a === expectedValue);
    case OperatorName.IS_NOT:
      return (actualValues: string[]): boolean => !actualValues.some((a) => a === expectedValue);
    case OperatorName.CONTAINS:
      return (actualValues: string[]): boolean => actualValues.some((a) => a.includes(expectedValue));
    case OperatorName.DOES_NOT_CONTAIN:
      return (actualValues: string[]): boolean => !actualValues.some((a) => a.includes(expectedValue));
    case OperatorName.GREATER_THAN:
      return (actualValues: string[]): boolean =>
        actualValues.some((a) => {
          switch (dataType) {
            case FilterSortDataType.NUMBER:
              return Number.parseFloat(a) > Number.parseFloat(expectedValue);
            default:
              return a > expectedValue;
          }
        });
    case OperatorName.GREATER_THAN_OR_EQUAL_TO:
      return (actualValues: string[]): boolean =>
        actualValues.some((a) => {
          switch (dataType) {
            case FilterSortDataType.NUMBER:
              return Number.parseFloat(a) >= Number.parseFloat(expectedValue);
            default:
              return a >= expectedValue;
          }
        });
    case OperatorName.LESS_THAN:
      return (actualValues: string[]): boolean =>
        actualValues.some((a) => {
          switch (dataType) {
            case FilterSortDataType.NUMBER:
              return Number.parseFloat(a) < Number.parseFloat(expectedValue);
            default:
              return a < expectedValue;
          }
        });
    case OperatorName.LESS_THAN_OR_EQUAL_TO:
      return (actualValues: string[]): boolean =>
        actualValues.some((a) => {
          switch (dataType) {
            case FilterSortDataType.NUMBER:
              return Number.parseFloat(a) <= Number.parseFloat(expectedValue);
            default:
              return a <= expectedValue;
          }
        });
    default:
      throw createError('UnsupportedFilterOperator', `Unsupported filter operator: ${operator}`);
  }
};
